import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["role", "aria-modal"]
const _hoisted_2 = { class: "form-close" }
const _hoisted_3 = { class: "aip-head" }
const _hoisted_4 = { class: "aip-sub" }
const _hoisted_5 = ["aria-checked", "onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "aip-opt-txt" }
const _hoisted_8 = {
  key: 0,
  class: "aip-chat",
  "aria-labelledby": "aip-chat-title"
}
const _hoisted_9 = { class: "aip-chat-head" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "aip-chat-sub" }
const _hoisted_12 = {
  ref: "log",
  class: "aip-log",
  "aria-live": "polite"
}
const _hoisted_13 = { class: "aip-msg ai" }
const _hoisted_14 = { class: "aip-who" }
const _hoisted_15 = {
  key: 0,
  class: "aip-msg ai aip-typing"
}
const _hoisted_16 = {
  key: 0,
  class: "aip-plan"
}
const _hoisted_17 = { class: "aip-plan-h" }
const _hoisted_18 = {
  key: 1,
  class: "aip-error",
  role: "alert"
}
const _hoisted_19 = {
  key: 2,
  class: "aip-applied",
  role: "status"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "aip-applied-acts" }
const _hoisted_22 = {
  key: 3,
  class: "aip-input"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 4,
  class: "aip-foot"
}
const _hoisted_26 = { class: "aip-hint" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "aip-spin",
  "aria-hidden": "true"
}
const _hoisted_29 = {
  key: 1,
  class: "aip-go"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_dictation = _resolveComponent("ai-dictation")!
  const _component_ai_process_modal = _resolveComponent("ai-process-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.docked ? 'aip-dock-wrap' : 'error-msg-wrap'),
      style: _normalizeStyle(_ctx.docked ? { top: _ctx.dockTop + 'px' } : undefined)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.docked ? 'aip aip-docked' : 'form-wrapper ai-modal aip slide-up'),
        role: _ctx.docked ? 'complementary' : 'dialog',
        "aria-modal": _ctx.docked ? undefined : 'true',
        "aria-labelledby": "aip-title"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "form-close-x",
            "aria-label": "Close",
            title: "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "aip-badge",
            "aria-hidden": "true"
          }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
            ])
          ], -1)),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("div", {
              id: "aip-title",
              class: "aip-title"
            }, "Improve with AI", -1)),
            _createElementVNode("div", _hoisted_4, "Pick how you want help. Nothing changes in your " + _toDisplayString(_ctx.noun) + " until you've seen the result and pressed Apply.", 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['aip-options', { compact: _ctx.messages.length && _ctx.choice == 'chat', brief: _ctx.docked }]),
          role: "radiogroup",
          "aria-label": "How should the AI help?"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o) => {
            return (_openBlock(), _createElementBlock("button", {
              key: o.key,
              type: "button",
              role: "radio",
              "aria-checked": _ctx.choice == o.key,
              class: _normalizeClass(['aip-opt', { on: _ctx.choice == o.key }]),
              onClick: ($event: any) => (_ctx.choose(o.key))
            }, [
              _createElementVNode("span", {
                class: "aip-opt-ic",
                innerHTML: o.icon
              }, null, 8, _hoisted_6),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(o.title), 1),
                _createElementVNode("span", null, _toDisplayString(o.text), 1),
                _createElementVNode("em", null, _toDisplayString(o.best), 1)
              ])
            ], 10, _hoisted_5))
          }), 128))
        ], 2),
        (_ctx.choice == 'chat')
          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "aip-chat-ic",
                  "aria-hidden": "true",
                  innerHTML: _ctx.chatIcon
                }, null, 8, _hoisted_10),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("h3", {
                    id: "aip-chat-title",
                    class: "aip-chat-title"
                  }, "Chat with the AI", -1)),
                  _createElementVNode("p", _hoisted_11, [
                    _createTextVNode("Tell it what to change in this " + _toDisplayString(_ctx.noun) + ". It keeps a list as you go, and nothing changes until you press ", 1),
                    _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Make these changes", -1)),
                    _cache[15] || (_cache[15] = _createTextVNode(".", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "aip-who" }, "AI", -1)),
                  _createElementVNode("div", null, [
                    _cache[17] || (_cache[17] = _createTextVNode("What would you like to change? Say it the way you'd tell a colleague. For example: ", -1)),
                    _createElementVNode("em", null, _toDisplayString(_ctx.example), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (m, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(['aip-msg', m.role == 'assistant' ? 'ai' : 'me'])
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(m.role == 'assistant' ? 'AI' : 'You'), 1),
                    _createElementVNode("div", null, _toDisplayString(m.text), 1)
                  ], 2))
                }), 128)),
                (_ctx.thinking)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("span", { class: "aip-who" }, "AI", -1),
                      _createElementVNode("div", null, [
                        _createElementVNode("i"),
                        _createElementVNode("i"),
                        _createElementVNode("i")
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 512),
              (_ctx.plan.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, "Changes to make (" + _toDisplayString(_ctx.plan.length) + ")", 1),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan, (p, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(p), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              (_ctx.applied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "aip-applied-h" }, "Changes made on the page", -1)),
                    (_ctx.appliedSummary.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedSummary, (c, i) => {
                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(c), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[21] || (_cache[21] = _createElementVNode("p", null, [
                      _createTextVNode("Look them over on the page. Nothing is saved until you press "),
                      _createElementVNode("strong", null, "Save"),
                      _createTextVNode(".")
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.keep()))
                      }, "Keep"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-btn ai-btn-ghost",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.undo()))
                      }, "Undo")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.applied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("textarea", {
                      ref: "input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.text) = $event)),
                      rows: "2",
                      disabled: _ctx.applying,
                      placeholder: "Type what you want changed, or tap the mic and talk…",
                      "aria-label": "Message to the AI",
                      onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.send()), ["exact","prevent"]), ["enter"]))
                    }, null, 40, _hoisted_23), [
                      [_vModelText, _ctx.text]
                    ]),
                    _createVNode(_component_ai_dictation, {
                      class: "aip-mic",
                      onText: _cache[5] || (_cache[5] = ($event: any) => (_ctx.text = (_ctx.text ? _ctx.text.trim() + ' ' : '') + $event))
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      class: "aip-send",
                      disabled: !_ctx.text.trim() || _ctx.thinking || _ctx.applying,
                      "aria-label": "Send",
                      title: "Send",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.send()))
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M5 12h14M13 6l6 6-6 6" })
                      ], -1)
                    ]))], 8, _hoisted_24)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.applied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.applying ? 'Making the changes… this usually takes 20–40 seconds.' : _ctx.canApply ? 'Ready when you are. You\'ll see the result before anything changes.' : 'Tell the AI what to change, then press Make these changes.'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(['ai-btn', { 'disable-button': !_ctx.canApply || _ctx.applying || _ctx.thinking }]),
                      disabled: !_ctx.canApply || _ctx.applying || _ctx.thinking,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.makeChanges()))
                    }, [
                      (_ctx.applying)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.applying ? 'Making changes…' : 'Make these changes'), 1)
                    ], 10, _hoisted_27)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (_ctx.choice == 'tuneup')
                ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                    _createTextVNode("The AI reads the whole " + _toDisplayString(_ctx.noun), 1),
                    (_ctx.nodeType == 'sheet')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(", every seat,")
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[23] || (_cache[23] = _createTextVNode(" and suggests a sharper version. You'll see a list of what it changed and can ask for more changes before applying.", -1)),
                    (_ctx.nodeType != 'sheet')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" It works from the last saved version, so save first if you've made edits you want it to keep.")
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_31, "Record your screen while you do the work, or upload a video, photos or the written procedure. The AI compares it with this process and drafts the update for you to review.")),
              _createElementVNode("button", {
                type: "button",
                class: "ai-btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sub = _ctx.choice))
              }, _toDisplayString(_ctx.choice == 'tuneup' ? 'Start the tune-up' : 'Continue'), 1)
            ]))
      ], 10, _hoisted_1)
    ], 6), [
      [_vShow, !_ctx.sub]
    ]),
    (_ctx.sub == 'tuneup')
      ? (_openBlock(), _createBlock(_component_ai_process_modal, {
          key: 0,
          mode: "improve",
          "node-type": _ctx.nodeType,
          slug: _ctx.slug,
          "current-draft": _ctx.nodeType == 'sheet' ? _ctx.currentDraft : null,
          "preview-base-node": _ctx.previewBaseNode,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sub = null)),
          onAccept: _ctx.accept
        }, null, 8, ["node-type", "slug", "current-draft", "preview-base-node", "onAccept"]))
      : _createCommentVNode("", true),
    (_ctx.sub == 'recording')
      ? (_openBlock(), _createBlock(_component_ai_process_modal, {
          key: 1,
          mode: "improve",
          "video-improve": true,
          slug: _ctx.slug,
          "accept-label": "Apply Update to Editor",
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sub = null)),
          onAccept: _ctx.accept
        }, null, 8, ["slug", "onAccept"]))
      : _createCommentVNode("", true),
    (_ctx.sub == 'review')
      ? (_openBlock(), _createBlock(_component_ai_process_modal, {
          key: 2,
          mode: "improve",
          "node-type": _ctx.nodeType,
          slug: _ctx.slug,
          "edit-only": true,
          "initial-draft": _ctx.revised,
          "initial-note": _ctx.feedbackText(),
          "preview-base-node": _ctx.previewBaseNode,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sub = null)),
          onAccept: _ctx.accept
        }, null, 8, ["node-type", "slug", "initial-draft", "initial-note", "preview-base-node", "onAccept"]))
      : _createCommentVNode("", true)
  ]))
}